const FalenciaRecuperacaoJudicial = ({ falenciaRecuperacaoJudicial }) => {
  if (
    !falenciaRecuperacaoJudicial ||
    falenciaRecuperacaoJudicial.length === 0
  ) {
    return (
      <div className="text-sm text-slate-500 italic">
        Nenhuma ocorrência de falência ou recuperação judicial encontrada.
      </div>
    );
  }

  const isEmpty = (val) => val == null || String(val).trim() === "" || String(val).trim() === "-";

  const hasTipo = falenciaRecuperacaoJudicial.some((o) => !isEmpty(o?.tipo_ocorrencia));
  const hasData = falenciaRecuperacaoJudicial.some((o) => !isEmpty(o?.data));
  const hasCidade = falenciaRecuperacaoJudicial.some(
    (o) => !isEmpty(o?.cidade) || !isEmpty(o?.uf)
  );

  const colCount = (hasTipo ? 1 : 0) + (hasData ? 1 : 0) + (hasCidade ? 1 : 0);
  const gridStyle = { gridTemplateColumns: `repeat(${colCount}, minmax(0, 1fr))` };

  return (
    <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white">
      <div className="border-b border-slate-200 bg-slate-50 px-4 py-3">
        <div
          className="grid gap-4 text-[10px] font-semibold uppercase tracking-[0.28em] text-slate-500"
          style={gridStyle}
        >
          {hasTipo && <div>Tipo</div>}
          {hasData && <div>Data</div>}
          {hasCidade && <div>Cidade / UF</div>}
        </div>
      </div>

      {falenciaRecuperacaoJudicial.map((ocorrencia, index) => (
        <div
          key={index}
          className={`grid items-center gap-4 px-4 py-3 text-sm transition-colors ${
            index % 2 === 0 ? "bg-white" : "bg-slate-50/40"
          } hover:bg-slate-50`}
          style={gridStyle}
        >
          {hasTipo && (
            <div className="font-medium text-slate-900">
              {ocorrencia?.tipo_ocorrencia || "-"}
            </div>
          )}
          {hasData && (
            <div className="font-medium text-slate-700">
              {ocorrencia?.data || "-"}
            </div>
          )}
          {hasCidade && (
            <div className="text-slate-700">
              {ocorrencia?.cidade || "-"} / {ocorrencia?.uf || "-"}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FalenciaRecuperacaoJudicial;
